module.exports = __webpack_public_path__ + "static/media/convince-guy.a935c82a.png";